import { useTranslation } from 'react-i18next';
import { Alert, Button } from '@mui/material';

type RefuelsErrorStateProps = {
  isRetrying: boolean;
  onRetry: () => void;
};

export function RefuelsErrorState({ isRetrying, onRetry }: RefuelsErrorStateProps) {
  const { t } = useTranslation();

  return (
    <Alert
      severity="error"
      action={
        <Button color="inherit" size="small" disabled={isRetrying} onClick={onRetry}>
          {t('error.dialog.tryAgain')}
        </Button>
      }
      data-qa-element-id="refuels_query_error"
      sx={{ m: 2 }}
    >
      {t('error.moduleOfOrigin.refuels')}
    </Alert>
  );
}
